import OverlayShape from './overlay_shape';

function Overlay(data, fromFlagship = false) {
  if (fromFlagship) {
    // Shapes are defined different when coming from flagship
    this.createFromFlagshipData(data)
  } else {
    var self = this;

    this.Id = data.Id;
    this.Name = data.Name;
    this.Shapes = [];
    this.Public = data.Public;

    data.Geometries.forEach(function(shape) {
      shape.OverlayId = self.Id;
      self.Shapes.push(new OverlayShape(shape));
    });
  }
}

Overlay.prototype = {
  constructor: Overlay,

  createFromFlagshipData: function(data) {
    var self = this;
    this.Id = data.db2_tech_id.replace('x','').replaceAll("'",'');
    this.Name = data.name;
    this.Shapes = [];
    this.Public = data.settings.public;

    data.shapes.forEach(function(shape) {
      shape.OverlayId = self.Id;
      self.Shapes.push(new OverlayShape(shape, true))
    })
  }

};

export default Overlay;
